import { render } from "./App.vue?vue&type=template&id=0ee960dd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/styles/app.css?vue&type=style&index=0&lang=css"

import exportComponent from "/media/diego-oliveira/ssd/projetos/andamento-da-obra-blend-pituba/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__